import { render, staticRenderFns } from "./modalHighlightedBusinessWallStatus.vue?vue&type=template&id=53a0e884&"
import script from "./modalHighlightedBusinessWallStatus.vue?vue&type=script&lang=js&"
export * from "./modalHighlightedBusinessWallStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports